<!-- 编辑设备详情弹框 -->
<template>
  <div class="operate-container">
    <div class="pageTabs">
      <el-tabs
        v-model="editableTabsValue"
        class="tabs"
        @tab-click="handleChange"
        @edit="handleTabsEdit"
      >
        <div class="nodata" v-if="editableTabs.length == 0">暂无类型</div>
        <el-tab-pane
          v-else
          :key="index"
          v-for="(item, index) in editableTabs"
          :label="item.operationConfigTypeName"
          :name="index.toString()"
        >
          <div slot="label">
            <el-tooltip placement="right">
              <div slot="content">
                <span class="icon">
                  <i
                    class="el-icon-edit"
                    title="编辑"
                    style="margin: 0 6px; cursor: pointer; font-size: 16px"
                    @click.stop="handleTabsEdit(index, 'edit')"
                  ></i>
                  <i
                    class="el-icon-close"
                    style="margin: 0 6px; cursor: pointer; font-size: 16px"
                    title="删除"
                    @click.stop="handleTabsEdit(index, 'remove')"
                  ></i>
                </span>
              </div>
              <span>{{ item.operationConfigTypeName }}</span>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="btn-container" style="line-height: 72px">
        <el-button
          type="text"
          class="point"
          @click="handleTabsEdit('', 'add')"
          icon="el-icon-circle-plus-outline"
          >新增类型</el-button
        >
      </div>
    </div>
    <!-- 步骤条 -->
    <div class="step-container">
      <el-scrollbar style="flex: 1" v-if="stepList.length">
        <el-timeline style="padding: 16px" class="timeLine">
          <el-timeline-item
            :timestamp="'步骤名称：' + item.stepName"
            placement="top"
            v-for="(item, index) in stepList"
            :key="index"
          >
            <!-- <p class="action"> -->
            <div class="step-row">
              <i class="el-icon-edit" @click="editStep(item, index)"></i>
              <i class="el-icon-delete" @click="deleteStep(item, index)"></i>
            </div>
            <!-- </p> -->
            <el-card class="step-cord">
              <h4>
                操作类型：{{ item.operationKeyType == 2 ? "固定输入" : "键盘输入" }}
              </h4>
              <p>内容：{{ item.inputContentStr }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-scrollbar>
      <div class="btn-container">
        <el-button type="info" @click="retBtn">取消</el-button>
        <el-button type="primary" @click="add">新增步骤</el-button>
      </div>
    </div>

    <!-- 新增/修改弹框 -->
    <add-config-dialog
      ref="addDialog"
      :state="state"
      :controlType="controlType"
      :deviceId="deviceId"
      :detail="deviceDetails"
      :stepInfo="stepInfo"
      @refresh="getSteps()"
    ></add-config-dialog>
    <!-- 新增类型弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-dialogDrag
      width="400px"
      class="choose-box"
      :before-close="cancleForm"
      :visible.sync="dialogConfigType"
    >
      <el-form :model="configForm" :rules="rules" ref="configForm" label-width="100px">
        <el-form-item label="类型名称" prop="name" label-width="100px">
          <el-input v-model="configForm.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleForm">取消</el-button>
        <el-button type="primary" @click="confirmForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic } from "$utils";
import addConfigDialog from "../components/addConfigDialog";
export default {
  components: {
    addConfigDialog,
  },
  data() {
    return {
      configTypePage: {
        pageSize: 1000,
        pageNum: 1,
        total: 0,
      },
      dialogTitle: "新增类型",
      configForm: {
        name: "",
        code: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入类型名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" },
        ],
      },
      dialogConfigType: false,
      editableTabsValue: "0",
      editableTabs: [],
      tabOptions: {
        column: Dic.find("SENU099"),
      },
      type: {},
      // 步骤条列表
      stepList: [
        {
          title: "输入密码",
        },
        {
          title: "设备二次码",
        },
        {
          title: "按“TAB”健",
        },
        {
          title: "输入要屏蔽的设备类型",
        },
        {
          title: "按确认健",
        },
      ],
      deviceDetails: {},
      deviceId: "",
      controlType: "", //海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
      state: 1, // 1: 新增 2：修改
      stepInfo: {},
    };
  },
  created() {
    if (this.$route.query.id) {
      this.deviceId = this.$route.query.id;
      this.getDeviceDetail();
      // this.getSteps();
      this.getConfigTypeList();
    }
  },
  mounted() {
    // 判断从控制页面返回
    // if (this.$route.query.id) {
    //   this.deviceId = this.$route.query.id;
    //   this.getDeviceDetail();
    //   this.getSteps();
    // }
    // this.type = this.tabOptions.column[0];
    // this.editableTabsValue = this.tabOptions.column[0].value;
    // this.editableTabs = this.tabOptions.column;
  },
  methods: {
    // 新增类型
    confirmForm() {
      this.$refs.configForm.validate((valid) => {
        if (valid) {
          let params = {
            deviceId: this.deviceId,
            operationConfigTypeName: this.configForm.name,
          };
          let url = api.addConfigTypeList;
          if (this.dialogTitle == "编辑类型") {
            params.operationConfigTypeCode = this.configForm.code;
            url = api.updateConfigTypeList;
          }
          this.$fetch(url, params).then((res) => {
            if (res && res.success) {
              this.getConfigTypeList();
              this.$message.success(res.msgContent || "操作成功");
              this.$refs.configForm.resetFields();
              this.dialogConfigType = false;
            } else {
              this.$message.error(res.msgContent || "操作失败");
            }
          });
        }
      });
    },
    // 获取模块类型配置并默认加载第一项
    getConfigTypeList() {
      this.stepList = [];
      let params = {
        deviceId: this.deviceId,
        pageNum: this.configTypePage.pageNum,
        pageSize: this.configTypePage.pageSize,
      };
      this.$fetch(api.queryConfigTypeList, params).then((res) => {
        if (res && res.success) {
          this.editableTabs = res.returnObj.list || [];
          this.configTypePage.total = res.returnObj ? res.returnObj.total : 0;
          this.type = res.returnObj.list[0];
          this.editableTabs.length && this.getSteps();
        } else {
          this.$message.error(res.msgContent || "获取数据失败");
        }
      });
    },
    cancleForm() {
      this.$refs.configForm.resetFields();
      this.dialogConfigType = false;
    },
    handleTabsEdit(targetName, action) {
      // 新增操作
      if (action === "add") {
        this.dialogTitle = "新增类型";
        this.dialogConfigType = true;
      }
      // 编辑操作
      if (action === "edit") {
        this.dialogTitle = "编辑类型";
        this.dialogConfigType = true;
        this.configForm.name = this.editableTabs[targetName].operationConfigTypeName;
        this.configForm.code = this.editableTabs[targetName].operationConfigTypeCode;
      }
      // 删除操作
      if (action === "remove") {
        this.$confirm(
          "确定对类型【" +
            this.editableTabs[targetName].operationConfigTypeName +
            "】执行删除操作？",
          "操作确认",
          {
            type: "warning",
          }
        )
          .then((res) => {
            this.$fetch(api.deleteConfigTypeList, {
              deviceId: this.deviceId,
              operationConfigTypeCode: this.editableTabs[targetName]
                .operationConfigTypeCode,
            }).then((res) => {
              if (res.success) {
                this.editableTabsValue =
                  targetName - 1 == -1 ? "0" : (targetName - 1).toString();
                this.getConfigTypeList();
                this.$message.success(res.msgContent || "删除成功 ");
              } else {
                this.$message.error(res.msgContent || "删除失败");
              }
            });
          })
          .catch((e) => {});
      }
    },
    // 切换选项卡
    handleChange(column) {
      this.type = this.editableTabs[Number(column.index)];
      this.getSteps();
    },
    add() {
      console.log(this.type);
      if (!this.type) {
        this.$message.warning("请先添加类型");
        return;
      }
      this.state = 1;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.operationConfigTypeCode);
      });
    },
    // 获取操作步骤列表
    getSteps() {
      let params = {
        deviceId: this.deviceId,
        operationConfigType: this.type.operationConfigTypeCode,
      };
      this.$fetch(api.config.queryConfigList, params).then((res) => {
        if (res && res.success) {
          this.stepList = res.returnObj;
        } else {
          this.$message.error("获取步骤失败");
        }
      });
    },
    // 查询设备详情
    getDeviceDetail() {
      let params = {
        deviceId: this.deviceId,
      };
      this.$fetch(api.getDeviceDetail, params).then((res) => {
        if (res && res.success) {
          let detail = res.returnObj.deviceInfo;
          if (!detail) {
            this.$message.error("暂无设备信息");
            return;
          }
          this.deviceDetails = res.returnObj.deviceInfo;
          if (this.deviceDetails.deviceType == "27") {
            // controlType 海湾CGS200  GTS200-1   GTS500 GTS500-1 2.物联网  北大JBF11FS-1  JBF11FS-2
            // FactoryId 1北大  2海湾 -1未知
            if (this.deviceDetails.subDeviceMark) {
              // 部件parentDeviceVersion/deviceVersion
              this.controlType = Dic.findByValue(
                "SENU095",
                this.deviceDetails.parentDeviceVersion
              );
            } else {
              // 主机
              this.controlType = Dic.findByValue(
                "SENU095",
                this.deviceDetails.deviceVersion
              );
            }
          } else {
            this.controlType = 2;
          }
        } else {
          this.$message.error("获取设备详情失败");
        }
      });
    },
    // 修改步骤内容
    editStep(data, index) {
      this.stepInfo = data;
      this.state = 2;
      this.$nextTick(() => {
        this.$refs.addDialog.open(this.type.value);
      });
    },
    // 删除步骤
    deleteStep(data, index) {
      this.$confirm(
        "确定对步骤【" + data.operationConfigTypeName + "】执行删除操作？",
        "操作确认",
        {
          type: "warning",
        }
      )
        .then((res) => {
          let params = {
            operationConfigCode: data.operationConfigCode,
          };
          this.$fetch(api.config.deleteConfigStep, params).then((res) => {
            if (res && res.success) {
              this.$message.success("删除步骤成功");
              this.getSteps();
            } else {
              this.$message.error(res.msgContent || "删除步骤失败");
            }
          });
        })
        .catch((e) => {});
    },
    retBtn() {
      this.$router.push({
        path: "/cameralist/fireDeviceList",
        name: "fireDeviceList",
        query: { device: this.$route.query.device },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.step-cord {
  color: #c3d3f5 !important;
  border: none !important;
  background-color: #0d121c !important;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
}
.timeLine {
  :deep .el-timeline-item__timestamp {
    font-size: 15px;
    // color: #ffffff;
  }
  :deep .el-timeline-item {
    &:hover {
      .step-row {
        display: block;
      }
    }
  }

  .el-timeline-item__content {
    // color: #ffffff;

    p {
      margin: 12px 0;
    }

    .action {
      position: absolute;
      top: -12px;
      right: 0;
      background: #407aee;
      color: #fff;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }

  :deep .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
}
.operate-container {
  height: 100%;
  position: relative;
  .btn-container {
    text-align: center;
    height: 50px;
    line-height: 50px;
    background: #181f2e;
    margin-bottom: 16px;
    .point {
      font-size: 15px;
    }
  }
  .pageTabs {
    display: flex;
    text-align: center;
    justify-content: center;
    margin-bottom: 10px;
    background: #181f2e;
    padding: 12px;
    .tabs {
      max-width: 90%;
      margin-right: 20px;
      .icon {
        margin-left: 50px;
        i {
          margin: 0 6px;
        }
      }
      .nodata {
        text-align: center;
        padding: 6px 0;
      }
    }
  }
  .step-container {
    height: calc(100% - 88px);
    display: flex;
    flex-direction: column;
    padding: 12px;
    background: #181f2e;
    position: relative;
  }
  .step-row {
    display: none;
    color: #fff;
    width: 65px;
    position: absolute;
    top: 3px;
    right: 0;
    margin-left: 60px;
    i {
      font-size: 18px;
      margin-right: 12px;
      cursor: pointer;
      &:hover {
        @include set_theme_color(color, active-border-color);
      }
    }
  }
}
</style>
